import {Argument} from 'classnames';

export interface BasePlainTextOrHtmlParams {
  className?: Argument;
  showHtml?: boolean;
  showTitle?: boolean;
  text: string;
}

export interface BasePlainTextOrHtmlParamsReturnType
  extends BasePlainTextOrHtmlParams {
  title?: string;
}

export default function basePlainTextOrHtmlParams(
  params: BasePlainTextOrHtmlParams
): BasePlainTextOrHtmlParamsReturnType {
  const {showTitle = false, text} = params;
  const title = showTitle ? text : undefined;

  return {...params, title};
}
